import { type FC, useEffect } from 'react';

import { IconCertified } from 'src/components/common/Certsy/Icons/IconCertified/IconCertified';
import { updateIntercomMarkDataAttributeTrue } from 'src/modules/intercom';
import { useStores } from 'src/utils/hooks/useStores';

import { intercomMessageKeys } from './IntercomMessageKeys';

const hasSeenVerifiedCertsyCredentials = 'has_seen_verified_certsy_credentials';

/**
 * IconCertifiedWithIntercom
 *
 * This component is a wrapper for IconCertified but everytime we use it, we'd mark the user with `has_seen_verified_certsy_credentials` attribute
 * This will trigger posts linked to has_seen_verified_certsy_credentials
 */
export const IconCertifiedWithIntercom: FC = () => {
  const { userStore } = useStores();

  useEffect(() => {
    if (!intercomMessageKeys[hasSeenVerifiedCertsyCredentials]) {
      intercomMessageKeys[hasSeenVerifiedCertsyCredentials] = true;
      updateIntercomMarkDataAttributeTrue(hasSeenVerifiedCertsyCredentials);
    }
  }, [userStore.user.userId]);

  return <IconCertified />;
};
